import React, { FC } from "react";
import "./MenuButton.scss";

export interface MenuButtonProps {
    onClick(): void;
    tabIndex?: string;
}

export const MenuButton: FC<MenuButtonProps> = (props) => {

    return (
        <div
            id="xapp-widget-menu"
            aria-label={"open menu"}
            aria-hidden={false}
            tabIndex={props.tabIndex ? Number(props.tabIndex) : 0}
            className="menu-button"
            onClick={props.onClick}>
        </div>
    );
};